import { useContext } from 'react';
import { VaccinationChartsDataContext } from '../contexts/VaccinationChartsDataContext';

export const useVaccinationChartsDataContext = () => {
    return useContext(VaccinationChartsDataContext);
};
